.signet-datagrid-container {
  font-family: Lato;
  font-weight: 400;

  .datagrid-title {
    font-size: 17px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .descripton {
    font-size: 12px;
  }

  .datagrid-heading {
    margin-bottom: 24px;
    display: flex;
    align-items: end;
    justify-content: space-between;

    .search-filter-container {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .more-filter-button {
        .filter-icon {
          line-height: 0 !important;
        }
      }

      .filter-drawer-container {
        position: relative;

        .filter-header {
          background-color: #f5f5f5;
          padding: 12px 24px;
          display: flex;

          .do-not-understand {
            color: #e33636;
            margin-left: 3px;
            font-size: 20px;
          }
        }

        .filter-body {
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding: 12px 24px;

          .select-container {
            position: relative;

            select {
              border: 1px solid rgba($color: #000000, $alpha: 0.2);
              border-radius: 6px;
              padding: 14px 6px;
              outline: 0;
              -webkit-appearance: none;
              -moz-appearance: none;
              width: 100%;

              &::-ms-expand {
                display: none;
              }
            }

            .select-icon {
              line-height: 0 !important;
              position: absolute;
              right: 0px;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }

          &.drawer {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 15px 30px;

            .select-container {
              position: relative;

              select {
                border: 1px solid rgba($color: #000000, $alpha: 0.2);
                border-radius: 6px;
                padding: 14px 6px;
                outline: 0;
                -webkit-appearance: none;
                -moz-appearance: none;
                width: 100%;

                &::-ms-expand {
                  display: none;
                }
              }

              .select-icon {
                line-height: 0 !important;
                position: absolute;
                right: 0px;
                top: 50%;
                transform: translate(-50%, -50%);
              }
            }

            .checkbox-container {
              display: grid;
              grid-template-columns: repeat(3, minmax(0, 1fr));
              gap: 10px;
            }
          }
        }

        .filter-footer {
          position: sticky;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;
          justify-content: space-between;
          background-color: #ffffff;
          width: 100%;
          padding: 16px 24px;
          border-top: 1px solid rgba($color: #000000, $alpha: 0.2);

          .footer-btn {
            width: 320px;
          }
        }
      }

      .eligible-filter,
      .member-filter,
      .provider-filter,
      .hcc-filter,
      .raf-filter {
        position: relative;

        &:not(:last-child) {
          margin-right: 10px;
        }

        .filter-button-dropdown {
          display: flex;
          border: 1px solid var(--action-default);
          padding: 6px 2px 6px 8px;
          border-radius: 6px;
          cursor: pointer;

          .filter-label {
            font-size: 14px;
            color: var(--action-default);
          }

          .dropdown-icon {
            color: var(--action-default);
            line-height: 0 !important;
            margin: 0;
          }

          &.active {
            &::after {
              background-color: var(--action-default);
              opacity: 0.2;
              display: block;
              content: "";
              width: 100%;
              height: 100%;
              z-index: -2;
              position: absolute;
              top: 0;
              left: 0;
            }
          }
        }

        .filter-container {
          position: absolute;
          right: 0;
          top: 120%;
          background-color: #ffffff;
          width: 350px;
          max-height: 400px;
          z-index: 100;
          border-radius: 6px;
          box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
          overflow: hidden;
          overflow-y: scroll;

          .filter-header {
            background-color: #f5f5f5;
            padding: 12px 24px;
            display: flex;

            .do-not-understand {
              color: #e33636;
              margin-left: 3px;
              font-size: 20px;
            }
          }

          .filter-body {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 12px 24px;

            &.flex-row {
              flex-direction: row;

              .select-container {
                select {
                  width: 140px;
                }
              }
            }

            .select-container {
              position: relative;
              flex: 1;

              select {
                border: 1px solid var(--gray-400);
                border-radius: 6px;
                padding: 14px 6px;
                outline: 0;
                -webkit-appearance: none;
                -moz-appearance: none;
                width: 100%;

                &::-ms-expand {
                  display: none;
                }
              }

              .select-icon {
                line-height: 0 !important;
                position: absolute;
                right: 0px;
                top: 50%;
                transform: translate(-50%, -50%);
                pointer-events: none;
              }
            }
          }

          .filter-footer {
            position: sticky;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            width: 100%;
            padding: 16px 24px;
            border-top: 1px solid rgba($color: #000000, $alpha: 0.2);
            z-index: 9999;

            .ok-btn {
              width: 140px;
            }

            .clear-btn {
              width: 140px;
            }
          }

          .month-container {
            display: grid;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: 10px;

            .month {
              display: grid;
              place-content: center;
              border: 1px solid var(--action-default);
              padding: 4px 8px;
              border-radius: 4px;
              cursor: pointer;

              &.selected {
                position: relative;

                &::after {
                  background-color: var(--action-default);
                  opacity: 0.2;
                  display: block;
                  content: "";
                  width: 100%;
                  height: 100%;
                  z-index: -2;
                  position: absolute;
                  top: 0;
                  left: 0;
                }
              }

              p {
                font-size: 14px;
                color: var(--action-default);
              }
            }
          }

          .gender-container {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 10px;

            .gender {
              display: grid;
              place-content: center;
              border: 1px solid var(--action-default);
              padding: 4px 8px;
              border-radius: 4px;
              cursor: pointer;

              &.selected {
                position: relative;

                &::after {
                  background-color: var(--action-default);
                  opacity: 0.2;
                  display: block;
                  content: "";
                  width: 100%;
                  height: 100%;
                  z-index: -2;
                  position: absolute;
                  top: 0;
                  left: 0;
                }
              }

              p {
                font-size: 14px;
                color: var(--action-default);
              }
            }
          }
        }
      }
    }

    .chosen-filters-container {
      display: flex;
      margin-top: 20px;

      .chosen-filter {
        padding: 4px 8px;
        border-radius: 100px;
        border: 1px solid var(--action-default);
        width: fit-content;
        margin-right: 10px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        &::before {
          background-color: var(--action-default);
          opacity: 0.2;
          display: block;
          content: "";
          width: 100%;
          height: 100%;
          z-index: -2;
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 100px;
        }

        p {
          color: var(--action-default);
          font-size: 14px;
          margin-right: 10px;
        }

        .close-icon {
          line-height: 0 !important;
          color: var(--action-default);
          cursor: pointer;
        }
      }
    }

    .filter-section {
      position: relative;

      .filter-column-container {
        position: absolute;
        top: 45%;
        left: 0;
        background-color: white;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
        padding: 16px;
        border-radius: 4px;
        z-index: 999;

        .switch-name-container {
          display: flex;
          align-items: start;

          &:not(:last-child) {
            margin-bottom: 20px;
          }

          p {
            margin-left: 16px;
            margin-top: -5px;
          }
        }
      }

      .action-container {
        display: flex;
        align-items: center;
      }

      .filter-button,
      .column-button {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        cursor: pointer;

        .filter-icon {
          line-height: 0 !important;
          margin-right: 4px;
        }

        p {
          font-size: 12px;
          margin: 0px !important;
        }
      }

      .filter-select {
        border: 0 !important;
        border-bottom: 1px solid gray !important;
        width: 100%;
        margin-bottom: 60px;

        &:focus {
          outline: 0 !important;
          border-bottom: 1px solid var(--action-default);
        }
      }

      .action-buttons {
        position: absolute;
        bottom: 20px;
        right: 20px;
        width: 100%;
        display: flex;
        justify-content: flex-end;

        .clear-button {
          margin-right: 10px;
        }
      }
    }

    .search-input-container {
      display: flex;
      margin-right: 10px;
      border-radius: 4px;

      .input-icon {
        display: flex;
        align-items: center;
        background-color: white;
        padding: 8px 8px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        border-radius: 4px;
        border-top: 1px solid #0000001f;
        border-bottom: 1px solid #0000001f;
        border-left: 1px solid #0000001f;
        border-right: 1px solid #0000001f;

        .search-icon {
          line-height: 0 !important;
          margin-right: 8px;
        }

        .search-input {
          background-color: transparent;
          border: 0;
          outline: 0;
          width: 300px;

          &:focus {
            outline: 0;
          }

          &::placeholder {
            color: #00000061;
          }
        }
      }

      .search-button {
        background-color: var(--primary-main);
        color: white;
        font-size: 14px;
        font-weight: 600;
        padding: 8px 22px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }

  .datagrid-table-container {
    border: 1px solid #d0d0d0;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    // height: 300px;
    overflow: scroll;

    .data-source-container {
      &:not(:last-child) {
        border-bottom: 1px solid #d0d0d0;
      }

      .subtable-columns,
      .subtable-datasource {
        display: grid;
        grid-auto-columns: max-content;
        padding: 12px;
      }

      .subtable-columns {
        background-color: #f5f5f5;
      }

      .subtable-datasource {
        background-color: white;
        &:not(:last-child) {
          border-bottom: 1px solid #d0d0d0;
        }
      }
    }

    .columns,
    .data-source {
      display: grid;
      grid-auto-columns: max-content;
      padding: 12px;
      position: relative;

      &.dense {
        padding: 6px;
      }

      &.selected {
        background-color: transparent;

        &::after {
          background-color: var(--action-default);
          opacity: 0.2;
          display: block;
          content: "";
          width: 100%;
          height: 100%;
          z-index: -2;
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      .arrow-icon {
        line-height: 0 !important;
      }
    }

    .columns {
      position: sticky;
      top: 0;
      z-index: 99;
      background-color: #f5f5f5;
      position: relative;

      .column {
        display: flex;
        align-items: center;
        white-space: nowrap;

        .header {
          font-weight: 500;
        }

        .icon {
          line-height: 0 !important;
          margin-left: 3px;
          display: none;
          cursor: pointer;
        }

        .normal {
          color: rgba(0, 0, 0, 0.2);
        }

        .asc,
        .desc {
          color: rgba(0, 0, 0, 1);
        }

        .filter-icon {
          line-height: 0 !important;
          display: none;
          margin-left: 3px;
          cursor: pointer;
        }

        &:hover {
          .icon {
            display: flex;
          }

          .filter-icon {
            display: flex;
          }
        }
      }

      .filter-container {
        position: absolute;
        left: 0;
        top: 100%;
        background-color: rgb(255, 255, 255);
        padding: 20px;
        border-radius: 6px;
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
        display: flex;

        .column-select {
          label {
            display: block;
            font-size: 12px;
            margin-bottom: 4px;
          }

          select {
            border-bottom: 1px solid gray;
            width: 150px;

            &:focus {
              outline: 0;
              border-bottom: 1px solid var(--action-default);
            }
          }
        }

        .operator-select {
          label {
            display: block;
            font-size: 12px;
            margin-bottom: 4px;
          }

          select {
            border-bottom: 1px solid gray;
            width: 150px;

            &:focus {
              outline: 0;
              border-bottom: 1px solid var(--action-default);
            }
          }
        }

        .filter-input-container {
          label {
            display: block;
            font-size: 12px;
            margin-bottom: 2px;
          }

          .filter-input {
            border-bottom: 1px solid gray;

            &:focus {
              outline: 0;
              border-bottom: 1px solid var(--action-default);
            }
          }
        }
      }
    }

    .data-source {
      cursor: pointer;
      background-color: white;

      // &:hover {
      //   background-color: rgba(0, 0, 0, 0.05);
      // }
    }

    .no-data {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100px;
    }
  }

  .pagination-controls {
    display: flex;
    align-items: center;
    justify-content: end;
    background-color: white;
    border-left: 1px solid #d0d0d0;
    border-bottom: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 12px;

    &.dense {
      padding: 6px;
    }

    .page-size-options {
      display: flex;
      align-items: center;

      .options-container {
        position: relative;

        .option-container {
          margin: 0 4px;
          padding: 2px 6px;
          cursor: pointer;
          display: flex;
          align-items: center;
        }

        .options {
          position: absolute;
          background-color: var(--gray-100);
          overflow: hidden;
          top: 100%;
          right: 0;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          border-radius: 4px;

          p {
            cursor: pointer;
            padding: 6px;
            width: 100%;
            display: flex;
            justify-content: center;

            &:hover {
              background-color: var(--gray-300);
            }

            &.selected {
              background-color: var(--primary-main);
              color: white;
            }
          }
        }
      }
    }

    .page {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin: 0 4px;

      &.active {
        background-color: var(--primary-main);
        color: #fff;
        border-radius: 50%;
      }
    }

    .previous,
    .next {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 4px;
      border: none;
      cursor: pointer;
      background: transparent;

      &[disabled] {
        cursor: not-allowed;
      }
    }
  }
}
